import { render, staticRenderFns } from "./voltageInfo.vue?vue&type=template&id=47bf8836&scoped=true"
import script from "./voltageInfo.vue?vue&type=script&lang=js"
export * from "./voltageInfo.vue?vue&type=script&lang=js"
import style0 from "./voltageInfo.vue?vue&type=style&index=0&id=47bf8836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bf8836",
  null
  
)

export default component.exports